import formatDate from 'root-packages/dates/formatDate.js'
import * as countries from 'root-config/resources/countries/index.js'
import * as gtmDataLayer from '../../../analytics/gtm/dataLayer.js'

class ZipMoneyCallbacks {
  constructor (api, booking, itineraryImage) {
    this.api = api
    this.leadPassenger = booking.booking.leadPassenger
    this.booking = booking
    this.itineraryImage = itineraryImage ? itineraryImage : ''
  }

  onadd () {
    gtmDataLayer.activateOptimize()
    const {internationalCode, areaCode, number} = this.leadPassenger.phoneNumber
    const details = {
      queryParams: {
        trigger: 1,
        shopper_title:this.leadPassenger.title,
        shopper_first_name: this.leadPassenger.firstName,
        shopper_last_name: this.leadPassenger.lastName,
        shopper_phone: internationalCode + areaCode + number,
        shopper_email: this.leadPassenger.emailAddress,
        shopper_gender: this.leadPassenger.gender,
        shopper_birth_date: formatDate(new Date(this.leadPassenger.dateOfBirth), 'YYYY-MM-DD'),
        shopper_billing_address_city: this.leadPassenger.address.city,
        shopper_billing_address_state: this.leadPassenger.address.region,
        shopper_billing_address_postal_code: this.leadPassenger.address.postcode,
        shopper_billing_address_country: countries.findByName(this.leadPassenger.address.country).alpha2,
        shopper_billing_address_first_name: this.leadPassenger.firstName,
        shopper_billing_address_last_name: this.leadPassenger.lastName,
        shopper_billing_address_line1: this.leadPassenger.address.line1,
        order_reference: this.booking.booking.bookingReference,
        order_items_type: 'Holiday',
        order_items_quantity: 1,
        order_items_name: this.booking.departure.name,
        order_currency: this.booking.departure.prices.currency,
        order_amount: this.booking.booking.totalAmount,
        order_items_amount: this.booking.booking.totalAmount,
        order_items_image_uri: this.itineraryImage,
        order_items_item_uri: window.location.href,
      },
    }
    this.api.loadFrame(details)
  }

  onupdate () {
    gtmDataLayer.activateOptimize()
  }

  close () {
    this.api.unloadFrame()
  }
}

class ZipMoney extends ZipMoneyCallbacks {
  constructor (booking, itineraryImage) {
    super(window.TTCZM, booking, itineraryImage)
  }

  render () {
  }
}

async function importLibrary (config) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = 1
    script.src = `${config.zipMoneyUrl}zipmoney/iframe-loader`
    script.onerror = function () {
      reject()
    }
    script.onload = function () {
      resolve()
    }
    document.head.appendChild(script)
  })
}

export default async function (payment, booking) {
  return await importLibrary(payment.config)
    .then(() => new ZipMoney(booking, payment.itineraryImage))
    .catch(() => false)
}
